import * as api from '@/backend/api'
import type { ParsedError } from '@/backend/error/types'
import { isErrorResponse } from '@/backend/error/types'
import { errorMessages, parseError } from '@/backend/error'

/**
 * Upload team avatar
 */
export const updateTeamAvatar = async (
  teamId: number,
  uploadUrl: string,
  image: Blob,
  type: string,
): Promise<ParsedError | void> => {
  try {
    await api.uploadToS3(uploadUrl, image, type)
    await api.post(`teams/${teamId}/confirm_avatar_uploaded`)
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return parseError(error, errorMessages.TEAM_REGISTER)
  }
}
